import { render } from "./BubbleText.vue?vue&type=template&id=16bc0ab4&scoped=true"
import script from "./BubbleText.vue?vue&type=script&lang=js"
export * from "./BubbleText.vue?vue&type=script&lang=js"

import "./BubbleText.vue?vue&type=style&index=0&id=16bc0ab4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bc0ab4"]])

export default __exports__